import { createSelector } from "reselect"
import { initialState } from "./reducer"

/**
 * Direct selector to the reportHome state domain
 */

const selectEngagementMeasurementDomain = (state) =>
  state.get("engagementMeasurement", initialState)

/**
 * Other specific selectors
 */
export const makeSelectIsLoading = () =>
  createSelector(selectEngagementMeasurementDomain, (state) =>
    state.get("isLoading")
  )

export const makeSelectIsLoadingDimensionsData = () =>
  createSelector(selectEngagementMeasurementDomain, (state) =>
    state.get("isLoadingDimensionsData")
  )

export const makeSelectMeasureEngagement = () =>
  createSelector(selectEngagementMeasurementDomain, (state) =>
    state.get("measureEngagement")
  )

export const makeSelectDimensionsData = () => createSelector(selectEngagementMeasurementDomain, (state) => state.get("dimensionsData"))

const makeSelectEngagementMeasurement = () =>
  createSelector(selectEngagementMeasurementDomain, (substate) =>
    substate.toJS()
  )


export default makeSelectEngagementMeasurement
export { selectEngagementMeasurementDomain }
